import {
  KYC_PARTNER_ACCOUNT_STATUS,
  KYC_PARTNER_LABELS,
  KYC_PARTNER_PENDING_SUBMISSION_STATUSES,
  RFI_STATUS,
} from 'modules/kyc/constants/constants';
import { KYB_STATUS } from 'modules/merchantinfo/constants/constants';

export const formatSummaryData = (data) =>
  [RFI_STATUS.RFI_REQUESTED, RFI_STATUS.RFI_SUBMITTED, RFI_STATUS.IN_REVIEW].map((status) => ({
    status: status,
    less_than_24_hours_count: data?.[status]?.less_than_24_hours_count,
    between_24_and_48_hours_count: data?.[status]?.between_24_and_48_hours_count,
    more_than_48_hours_count: data?.[status]?.more_than_48_hours_count,
    more_than_7_days_count: data?.[status]?.more_than_7_days_count,
  }));

export const formatRfiStatus = (status) => {
  switch (status) {
    case RFI_STATUS.RFI_REQUESTED:
      return 'REQUESTED';
    case RFI_STATUS.RFI_SUBMITTED:
      return 'SUBMITTED';
    case RFI_STATUS.IN_REVIEW:
      return 'IN REVIEW';
    case RFI_STATUS.RFI_DELAYED:
      return 'DELAYED';
    case KYB_STATUS.SUCCEEDED:
    case KYB_STATUS.APPROVED:
      return 'ACTIVE';
    default:
      return 'N/A';
  }
};

export const getRfiStatusBadgeColor = (status) => {
  switch (status) {
    case RFI_STATUS.RFI_REQUESTED:
      return 'blue';
    case RFI_STATUS.IN_REVIEW:
      return 'yellow';
    case RFI_STATUS.RFI_SUBMITTED:
    case KYB_STATUS.SUCCEEDED:
    case KYB_STATUS.APPROVED:
      return 'green';
    case RFI_STATUS.RFI_DELAYED:
      return 'red';
    default:
      return 'gray';
  }
};

export const getRfiThread = (kycDetails, currentRfi, rfiThread = []) => {
  const parentRfi =
    currentRfi?.parent_rfi_id && kycDetails?.rfi_submitted?.find((rfi) => rfi?.id === currentRfi?.parent_rfi_id);

  if (parentRfi) {
    rfiThread.push({
      ...JSON.parse(parentRfi?.value),
      created_at: parentRfi?.created_at,
      signed_rfi_document_urls: parentRfi?.signed_rfi_document_urls,
      id: parentRfi?.id,
      parent_rfi_id: parentRfi?.parent_rfi_id,
    });

    return getRfiThread(kycDetails, parentRfi, rfiThread);
  }

  return rfiThread;
};

export const formatKycPartnerLabel = (partnerCode) => KYC_PARTNER_LABELS[partnerCode] ?? partnerCode ?? 'partner';

export const formatPartnerAccountStatus = (status) => (status ? status.replace(/_/g, ' ') : 'N/A');

export const getPartnerAccountStatusBadgeColor = (status) => {
  switch (status) {
    case KYC_PARTNER_ACCOUNT_STATUS.DRAFT:
      return 'gray';
    case KYC_PARTNER_ACCOUNT_STATUS.ACTION_REQUIRED:
      return 'orange';
    case KYC_PARTNER_ACCOUNT_STATUS.PROCESSING:
    case KYC_PARTNER_ACCOUNT_STATUS.UNDER_REVIEW:
      return 'yellow';
    case KYC_PARTNER_ACCOUNT_STATUS.APPROVED:
      return 'green';
    case KYC_PARTNER_ACCOUNT_STATUS.REJECTED:
      return 'red';
    default:
      return 'gray';
  }
};

export const isPartnerSubmissionPending = (status) =>
  !status || KYC_PARTNER_PENDING_SUBMISSION_STATUSES.includes(status);
